module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "loan-consultants"
  }, [_c('div', {
    staticClass: "consultant-box"
  }, [_c('div', {
    staticClass: "side"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.counselorInfo.logoUrl),
      expression: "counselorInfo.logoUrl"
    }],
    staticClass: "media-object",
    attrs: {
      "src": _vm.counselorInfo.logoUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "square"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.counselorInfo.wxQrcodeUrl),
      expression: "counselorInfo.wxQrcodeUrl"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.counselorInfo.wxQrcodeUrl
    }
  })]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.counselorInfo.name))]), _vm._v(" "), _c('span', {
    staticClass: "job"
  }, [_vm._v(_vm._s(_vm.counselorInfo.profession))])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, [_c('li', [_c('span', {
    staticClass: "phone"
  }, [_vm._v("电话:")]), _vm._v(" " + _vm._s(_vm.counselorInfo.phone))]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "wechat"
  }, [_vm._v("微信:")]), _vm._v(" " + _vm._s(_vm.counselorInfo.wechat))])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "profile"
  }, [_c('span', {
    staticClass: "intro"
  }, [_vm._v("简介:")]), _vm._v(_vm._s(_vm.counselorInfo.personalProfile))])])]), _vm._v(" "), _c('div', {
    staticClass: "order"
  }, [_c('button', {
    staticClass: "orderBtn",
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("预约借款服务")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7c08af76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/consultant/person.vue
// module id = 615
// module chunks = 1